<template>
  <div class='login-body auto-bg' id='login'>
    <div class='login-main'>
      <div class='wrap'>
        <div class='clearfix fr login-box-wrap'>
          <form class='fr' action='/uaa/login' method='post' id='loginForm'>
            <div class='login-box fr'>
              <div class='login-box-tit'>
                <span
                  class='comp tit c-b3b3b3 fs-16 pointer sensors-data'
                  :class='{"c-blue": loginType=="isPwd" ,"fs-22":loginType=="isPwd"}'
                  v-on:click='loginTypeChoose("isPwd")'
                >账号密码登录</span>
                <span
                  class='finance tit c-b3b3b3 fs-16 pointer sensors-data'
                  :class='{"c-blue": loginType=="notPwd" ,"fs-22":loginType=="notPwd"}'
                  v-on:click='loginTypeChoose("notPwd")'
                >短信验证登录</span>
              </div>
              <ul>
                <li class='corp'>
                  <div class='login-itme'>
                    <span class='i i1'>机构名称/代码</span>
                    <span class='input pr' :class='{error: nameError!=""}'>
                      <input
                        type='text'
                        placeholder='请输入机构名称/代码'
                        v-model.trim='name'
                        name='name'
                        v-on:blur='nameBlur()'
                      >
                      <span class='error-span'>{{nameError}}</span>
                    </span>
                  </div>
                </li>
                <li>
                  <div class='login-itme'>
                    <span class='i i2'>手机号码</span>
                    <span class='input pr' :class='{error: telephoneError!=""}'>
                      <input
                        type='text'
                        placeholder='请输入手机号码'
                        v-model.trim='telephone'
                        name='mobile'
                        v-on:blur='telephoneBlur()'
                      >
                      <span class='error-span'>{{telephoneError}}</span>
                    </span>
                  </div>
                </li>
                <li v-if='loginType=="isPwd"'>
                  <div>
                    <div class='login-itme'>
                      <span class='i i3'>登录密码</span>
                      <span class='input pr' :class='{error: passwordError!=""}' id='passwordInput'>
                        <input
                          type='password'
                          placeholder='请输入登录密码'
                          v-model='password'
                          id='password'
                          v-on:blur='passwordBlur()'
                        >
                        <span class='error-span'>{{passwordError}}</span>
                      </span>
                      <input type='hidden' name='bizPass' id='bizPass'>
                    </div>
                  </div>
                </li>
                <li v-if='loginType=="notPwd"'>
                  <div class='notPwd'>
                    <div class='login-itme'>
                      <!-- <span class='i i1-1'></span> -->
                      <span
                        class='input w155 pl15'
                        :class='{error: msgError!=""}'
                        id='smsVerifyCodeInput'
                      >
                        <input
                          class='w130'
                          placeholder='请输入短信验证码'
                          v-model='smsVerifyCode'
                          name='smsVerifyCode'
                          v-on:blur='smsVerifyCodeBlur()'
                          maxlength='6'
                        >
                        <span class='error-span'>{{msgError}}</span>
                      </span>
                      <a
                        href='javascript:;'
                        class='btn current btn-106-36 fw-bold c-white ml10'
                        v-on:click='sendMsg' style="border:none;"
                      >{{sendMsgText}}</a>
                    </div>
                  </div>
                </li>
                <li class='clearfix code' v-if='loginType=="isPwd" && showVerifyCode'>
                  <div class='fl'>
                    <span class='input pr' :class='{error: verifyCodeError!=""}'>
                      <input
                        type='text'
                        maxlength='4'
                        placeholder='请输入验证码'
                        v-model='verifyCode'
                        name='verifyCode'
                        v-on:blur='verifyCodeBlur()'
                      >
                      <span class='error-span'>{{verifyCodeError}}</span>
                    </span>
                  </div>
                  <div class='fl pic-code'>
                    <img class="sensors-data" :src='captcha' v-on:click='picReload'>
                  </div>
                </li>
                <!-- <li v-if="loginVersion" style="clear:both;">
                    <div>
                        <div class="login-itme">
                            <span class="i i3">登录版本</span>
                            <span class="ml-100 mr-20 fv-choose sensors-data" :class="{'current': fvChoose === 'fv2'}" @click="fvChoose='fv2'">企业端2.0</span>
                            <span class="fv-choose sensors-data" :class="{'current': fvChoose === 'fv3'}" @click="fvChoose='fv3'">企业端3.0</span>

                        </div>
                    </div>
                </li> -->
                <li class='mt20 mb20'>
                  <input value='登录' type='button' id="loginSubmit" class='sub pointer ' v-on:click='submit'>
                </li>
                <li class='clearfix login-info fs-13'>
                  <div class='fl'>
                    <span
                      class='btn-checkbox border-808080 sensors-data'
                      :class='{current: remembered}'
                      @click='remembered = !remembered'
                    >
                      <span class='fs-13 c-808080'>记住机构信息</span>
                    </span>
                  </div>
                  <div class='fr lh25'>
                    <!-- <router-link  class='c-blue c-808080' to="../register/reset-password">忘记密码</router-link> -->
                    <router-link  class='c-blue c-808080' to="/reset-password">忘记密码</router-link>
                    <!-- <span @click="toRegister"><a href='https://corp.ccbscf.com/corp/register/fill_base_info.html' class='c-blue'>马上注册</a></span> -->
                  </div>
                </li>
                <li>
                  <div class='single-error'>{{loginErrorMsg}}</div>
                </li>
              </ul>
            </div>
            <input type='hidden' id='redirect_uri' name='redirect_uri'>
            <input type='hidden' id='csrf_token' name='_csrf'>
            <input type='hidden' id='type' name='type' value='CCBSCF_FINANCE_WEB'>
            <input type="hidden" id="sv" name="sv" value="V30" />
            <!-- <div v-if="domain.indexOf('demo') > -1">
                <input type="hidden" id="fv" name="fv" value="V20" v-if="fvChoose === 'fv2'" />
                <input type="hidden" id="fv" name="fv" value="V30" v-else/>
            </div> -->
            <input type='hidden' id='rememberFlag' name='rememberFlag' v-model='remembered'>
            <input type='hidden' id='isSmsLogin' name='isSmsLogin' v-model='isSmsLogin'>
            <input type='hidden' id='anonymousId' name='anonymousId' v-model='anonymousId'>
          </form>
        </div>
      </div>
      <modal-dialog v-if='alertBox'>
        <h1 class='dialog-header fs-20' slot='header'>提示信息</h1>
        <span class='dialog-close sensors-data' slot='close' @click='closeDialog'></span>
        <div slot='body'>
          <div class='tal pt40'>{{alertBoxMsg}}</div>
        </div>
        <div slot='footer'>
          <a class='btn btn-border bg-blue btn-140-40 c-white fs-16' @click='closeDialog'>确认</a>
        </div>
      </modal-dialog>
      <div id='ccbcadiv'></div>
      <div id='ccbcact'></div>
      <div id='cfcaDiv'></div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
// import { mapState } from 'vuex'
import { navJudge, cookie, encryptPwd, regExp } from '@/libs/util'
import ajax from '@/libs/ajax'
// import Config from '@/config'

export default {
  data () {
    return {
      isHide: false,
      switchbarStatus: false,
      username: '',
      name: '',
      telephone: '',
      password: '',
      passwordRandom: '',
      verifyCode: '',
      loginErrorMsg: '',
      nameError: '',
      telephoneError: '',
      passwordError: '',
      verifyCodeError: '',
      captcha: '',
      captchaURL: '/uaa/v1/captcha/image',
      token: '',
      // switchBool: false,
      alertBox: false,
      alertBoxMsg: '',
      isLoading: false,
      showVerifyCode: false,
      remembered: true,
      cookie: {
        name: '', // 企业名称
        mobile: '', // 企业手机号
        code: '', // 金融机构代码号
        finMobile: '' // 金融机构手机号
      },
      cpLock: true,
      // isWin: true
      isWin: !!(
        navigator.userAgent.indexOf('Windows NT 10.0') > -1 ||
        navigator.userAgent.indexOf('Windows NT 6.1') > -1
      ),
      bowser: {},
      supportControls: false,
      showDetect: false,
      loginType: 'isPwd',
      smsVerifyCode: '',
      msgError: '',
      sendMsgText: '获取验证码',
      isSmsLogin: '',
      random: '', // 随机因子
      publicKey: '', // 公钥
      anniversaryShowFlag: false,
      // fvChoose: 'fv2',
      domain: document.domain.split('.')[0],
      // loginVersion: false,
      switchBool: false,
      anonymousId: ''
    }
  },
  computed: {
    // // switchBool () {
    // //   return this.$store.state.corpInfo.switchBool
    // // }
    // ...mapState(['corpInfo'])
  },
  created () {
    // 获取图片验证码
    this.picReload()
    // common();
    this.loginStatus()
    // 记住企业信息
    this.rememberMe()
    // 定时器 十分钟刷新一次页面
    setInterval(function () {
      window.location.reload()
    }, 1000 * 60 * 10)
  },
  mounted () {
    if (navJudge() === 'isIE11') {
      this.isHide = true
    } else {
      this.isHide = false
    }
    this.enterFn()
    this.getToken()
    // this.getVersion()
    // this.loginVersion = (this.domain.indexOf('demo') > -1 || this.domain.indexOf('int') > -1) && this.corpInfo.switchBool
    // console.log(this.corpInfo.switchBool, 'this.corpInfo.switchBool')
  },
  beforeRouteLeave (to, from, next) {
    this.autoCalcFooterMargin(true)
    next()
  },
  methods: {
    getVersion () {
      let _this = this
      ajax.get('/v1/auth/cfca/controls/enable').then((res) => {
        _this.switchBool = res.data
        // if ((_this.domain.indexOf('demo') > -1 || _this.domain.indexOf('int') > -1) && _this.switchBool) {
        //   _this.loginVersion = true
        // }
      })
    },
    // 获取短信验证码
    sendMsg: function () {
      if (this.sendMsgBoxStaus === 'sending') return false // 正在发送验证 直接返回

      if (!this.telephoneBlur('telephone')) return false // 校验手机格式是否正确

      this.sendMsgBoxStaus = 'sending'
      var _this = this
      var timer = null
      var n = 60
      clearInterval(timer)

      timer = setInterval(function () {
        n--
        _this.sendMsgText = '还有' + n + '秒'
        if (n <= 0) {
          clearInterval(timer)
          _this.sendMsgText = '重新获取'
          _this.sendMsgBoxStaus = ''
        }
      }, 1000)

      $.ajax({
        url: '/uaa/v1/verify-code/sms?t=' + new Date().getTime(),
        type: 'get',
        data: {
          name: this.name,
          mobile: this.telephone,
          type: 'CCBSCF_FINANCE_WEB'
        },
        success (data) {
          if (data.code === '0') {
            _this.token = data.data
          } else if (data.code === '99999999') {
            _this.$Tip.error({
              content: data.message
            })
            // _this.modalBoxShow(data.message)
            clearInterval(timer)
            _this.sendMsgText = '获取验证码失败， 请重新获取。'
            _this.sendMsgBoxStaus = ''
          } else {
            _this.$Tip.error({
              content: data.message
            })
            // _this.modalBoxShow(data.message)
            clearInterval(timer)
            _this.sendMsgText = '重新获取'
            _this.sendMsgBoxStaus = ''
          }
        },
        fail (error) {
          _this.$Tip.error({
            content: error.message
          })
          // _this.modalBoxShow(error.message)
          clearInterval(timer)
          _this.sendMsgText = '重新获取'
          _this.sendMsgBoxStaus = ''
        }
      })
    },
    enterFn () {
      var _this = this
      $('input').on({
        compositionstart: function () {
          // 中文输入开始
          _this.cpLock = false
        },
        compositionend: function () {
          // 中文输入结束
          _this.cpLock = true
        },
        keydown: function (e) {
          if (_this.cpLock && e.keyCode === 13) {
            _this.submit()
          }
        }
      })
    },
    rememberMe: function () {
      var name = cookie.get("name"),
          mobile = cookie.get("mobile"),
          //资金端
          code = cookie.get("code"),
          finMobile = cookie.get("finMobile");
      this.cookie.name = name ? decodeURI(name) : "";
      this.cookie.mobile = mobile ? mobile : "";
      this.cookie.code = code ? decodeURI(code) : "";
      this.cookie.finMobile = finMobile ? finMobile : "";

      if (this.cookie.code) {
          this.remembered = true;
          this.name = this.cookie.code;
          this.telephone = this.cookie.finMobile;
      } else {
          this.remembered = false;
      }
    },
    closeDialog: function () {
      this.alertBox = false
    },
    // modalBoxShow: function (msg) {
    //   this.alertBox = true
    //   this.alertBoxMsg = msg
    // },
    loginStatus: function () {
      ajax.get('/login').then(
        data => {
          this.random = data.random
          this.publicKey = data.data.key

          if (data.code !== '0' && data.code !== '-1') {
            if (data.code === '99999999') {
              this.$Tip.error({
                content: '获取验证码失败， 请重新获取。'
              })
              // this.modalBoxShow('获取验证码失败， 请重新获取。')
            } else {
              this.$Tip.error({
                content: data.message
              })
              // this.modalBoxShow(data.message)
            }
          }
          if (
            (data.code === '-1' && data.data.showPicture) ||
            (data.code !== '0' && data.code !== '-1')
          ) {
            this.showVerifyCode = true
          }
        },
        data => {
          this.publicKey = data.data.key
          if (data && data.code && data.code !== '0' && data.code !== '-1') {
            if (data.code === '99999999') {
              this.$Tip.error({
                content: '获取验证码失败， 请重新获取。'
              })
            } else {
              this.$Tip.error({
                content: data.message
              })
            }
          }
          if (
            (data && data.code === '-1' && data.data.showPicture) ||
            (data && data.code !== '0' && data.code !== '-1')
          ) {
            this.showVerifyCode = true
          }
        }
      )
    },
    getToken: function (fn) {
      $.ajax({
        url: '/uaa/token?nocache=' + new Date().getTime(),
        type: 'get',
        async: false,
        success: function (data) {
          if (data.code === '0') {
            $('#csrf_token').val(data.data.token)
            fn && fn()
          }
        }
      })
    },
    switchbarClick: function () {
      this.switchbarStatus = !this.switchbarStatus
    },
    loginTypeChoose: function (loginType) {
      if (loginType === 'notPwd') {
        this.isSmsLogin = 'true'
      } else {
        this.isSmsLogin = ''
      }
      this.loginType = loginType
    },
    submit: function () {
      var _this = this

      // 先检测token是否已获取到
      if (this.loginType === 'isPwd' && !$('#csrf_token').val()) {
        this.getToken()
        this.loginStatus()
      }

      if (!this.submitValid()) return

      this.$Spin.show()

      if (this.loginType === 'isPwd') {
        let encryptPwdVal = encryptPwd(this.publicKey, this.password)

        $('#bizPass').val(encryptPwdVal)

        document.getElementById('loginForm').submit()
      } else {
        if (!this.token) {
          this.$Tip.error({
            content: '请获取短信验证码'
          })
          this.$Spin.hide()
          return
        }
        $.ajax({
          url: '/uaa/v1/login/sms?t=' + Math.random(),
          type: 'get',
          data: {
            name: this.name,
            mobile: this.telephone,
            type: 'CCBSCF_FINANCE_WEB',
            verifyCode: this.smsVerifyCode,
            token: this.token,
            isSmsLogin: this.isSmsLogin,
            rememberFlag: this.remembered
            // anonymousId: sensors.quick('getAnonymousID')
          },
          success: function (data) {
            if (data.code === '0') {
              window.location.href = data.data
            } else {
              _this.$Tip.error({
                content: data.message
              })
            }
            _this.$Spin.hide()
          },
          error: function (data) {
            _this.$Tip.error({
              content: data.message
            })
            _this.$Spin.hide()
          }
        })
      }
    },
    submitValid: function () {
      if (!this.nameBlur() || !this.telephoneBlur()) {
        return false
      }

      if (this.loginType === 'isPwd') {
        if (!this.passwordBlur()) {
          return false
        }
      } else {
        if (!this.smsVerifyCodeBlur()) {
          return false
        }
      }

      if (this.loginType === 'isPwd' && this.showVerifyCode) {
        if (!this.verifyCodeBlur()) {
          return false
        }
      }
      return true
    },
    // 企业全称
    nameBlur: function() {
        this.name = this.name.replace(/\s+/g, "").replace(/\(+/g, "（").replace(/\)+/g, "）");
        if (!/^\S+$/.test(this.name)) {
            this.nameError = "此处不能为空";
            return false;
        }
        this.nameError = "";
        return true;

    },
    // 手机号码
    telephoneBlur: function () {
      if (!/^\S+$/.test(this.telephone)) {
          this.telephoneError = "此处不能为空";
          return false;
      } else if (!new RegExp(regExp.phone).test(this.telephone)) {
          this.telephoneError = "手机号码格式错误，请重新输入";
          return false;
      } else {
          this.telephoneError = "";
          return true;
      }
    },
    // 密码
    passwordBlur: function () {
      if (!/^\S+$/.test(this.password)) {
        this.passwordError = '此处不能为空'
        return false
      } else {
        this.passwordError = ''
        return true
      }
    },
    // 短信验证码
    smsVerifyCodeBlur: function () {
      if (!this.telephoneBlur()) {
        return false
      } else if (!this.smsVerifyCode) {
        this.msgError = '此处不能为空'
        return false
      } else if (!/^\S{6}$/.test(this.smsVerifyCode)) {
        this.msgError = '短信验证码输入错误'
        return false
      } else {
        this.msgError = ''
        return true
      }
    },
    // 验证码
    verifyCodeBlur: function () {
      if (!this.verifyCode) {
        this.verifyCodeError = '此处不能为空'
        return false
      } else if (!/^\S{4}$/.test(this.verifyCode)) {
        this.verifyCodeError = '验证码输入错误'
        return false
      } else {
        this.verifyCodeError = ''
        return true
      }
    },
    // 刷新验证码图片
    picReload: function () {
      this.captcha = this.captchaURL + '?nocache=' + new Date().getTime()
    },
    // 系统检测
    detectOS () {
      // var sUserAgent = navigator.userAgent
      var isWin =
        navigator.platform === 'Win32' || navigator.platform === 'Windows'
      if (isWin) {
        this.bowser.os = 'Windows 系统'
        this.bowser.supportOs = true
      } else {
        this.bowser.os = '非 Windows 系统'
        this.bowser.supportOs = false
      }
      // 浏览器检测
      var nav = navJudge()
      nav = nav.substr(2)
      if (nav === 'FF') nav = 'Firefox'
      this.bowser.bowser = nav
      if (nav === 'Edge' || nav === 'IE11' || nav === 'IE10' || nav === 'IE9') {
        this.bowser.supportBowser = true
      } else {
        this.bowser.supportBowser = false
      }
      // 控件检测

      if (window.supportControls) {
        this.supportControls = true
      } else {
        this.supportControls = false
      }
      // 系统检测弹框
      if (
        this.bowser.supportOs &&
        this.bowser.supportBowser &&
        this.supportControls
      ) {
        this.showDetect = false
      } else {
        this.showDetect = true
      }

      this.switchbarStatus = this.showDetect
    },
    // 下载安全控件
    uploTool () {
      window.open(process.env.BASE_URL + 'cfca/CryptoKit.CCBTRUST.exe')
    },
    // 下载IE11
    uploadIE () {
      window.open('http://download.microsoft.com/download/F/2/8/F2871AC4-E82B-4636-BB37-A5F2B14C8616/IE11-Windows6.1-x86-zh-cn.exe')
    },
    // 根据活动广告计算底部margin
    autoCalcFooterMargin (isClose) {
      $('.new-footer').css('margin-bottom', isClose ? 0 : this.$refs.anniversary.clientHeight)
    }
  },
  components: {
    // modalDialog,
    // loading,
    // rightMenu
  }
}
</script>

<style lang="less" scoped>
@import "../../styles/common";

.to-register {
  display: inline-block;
  color: #215BBF;
  line-height: 25px;
  cursor: pointer;
}

.ietip {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #fffdf1;
  font-size: 14px;
}

.login-body {
  // position: absolute;
  height: 100%;
  // min-height: 850px;
  width: 100%;
  min-width: 1200px;
}

.login-body .wrap {
  width: 1200px;
  margin: 0 auto;
}

// .auto-bg {
//   background: url(../../assets/images/login-bg.png) no-repeat;
//   background-position: center;
//   background-size: cover;
// }

.login-header {
  position: relative;
  /*left: 0;
    top: 0;*/
  height: 70px;
  width: 100%;
  background: #205bbe;
}

.login-header .logo {
  margin: 15px 20px 0 0;
}

.login-header .login-jxt {
  display: inline-block;
  height: 30px;
  margin-top: 22px;
  padding-left: 20px;
  border-left: 1px solid #f5f6fb;
  color: #f5f6fb;
  font-size: 18px;
}

.login-header .phone {
  color: #fff;
  font-size: 16px;
  height: 70px;
  line-height: 70px;
}

.login-main {
  width: 100%;
  height: 600px;
  overflow: hidden;
  background: url('../../assets/images/login-bg.png') no-repeat;
  background-position: center;
  background-size: cover;
}

.login-box-wrap {
  /* height: 458px; */
  position: relative;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  margin-top: 70px;
}


.login-main .move {
  display: inline-block;
  width: 0;
  -webkit-transition: all ease-in-out 0.4s;
  -moz-transition: all ease-in-out 0.4s;
  -ms-transition: all ease-in-out 0.4s;
  -o-transition: all ease-in-out 0.4s;
  transition: all ease-in-out 0.4s;
  overflow: hidden;
}


.login-box {
  width: 440px !important;
}

.login-box .login-box-tit {
  padding: 50px 54px 0;
  text-align: center;
}

.login-box .login-box-tit .comp {
  padding-right: 22px;
}

.login-box ul {
  padding: 40px 54px 20px !important;
}

.c-b3b3b3 {
  color: #b3b3b3;
}

.login-box .login-box-tit .finance {
  padding-left: 22px;
  border-left: 1px solid #ccc;
}

.login-box .input,
.login-box .input > input {
  width: auto;
}

.login-box .input {
  margin-bottom: 16px;
  padding-left: 128px;
}

.login-box .input > input {
  width: 180px;
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  vertical-align: top;
}

.login-box .code .input {
  padding: 0 10px;
  width: 140px !important;
  margin-right: 10px;
}

.login-box .code .input > input {
  width: 126px !important;
}

.login-box .pic-code img {
  width: 120px !important;
  height: 36px;
}

.login-box .sub {
  display: block;
  background: @basic-color;
  height: 45px;
  color: #fff;
  width: 100%;
  font-size: 13px;
  border: 0;
  .border-radius(5px);
  // transition: all 0.2s ease-in-out;
  &:hover {
    background: tint(@basic-color, 20%);
  }
}

.login-box .login-info .btn-checkbox > span {
  display: inline-block;
  width: 88px;
  color: #215bbf;
}

.w0 {
  width: 0px !important;
  height: 0px !important;
}

.w710 {
  width: 710px !important;
  height: 430px !important;
}

.single-error {
  display: block;
  height: 40px;
  line-height: 40px;
  color: #e92b2b;
  font-size: 12px;
}

.login-itme .input .error-span {
  position: absolute;
  left: 16px;
  top: 26px;
  color: #e92b2b;
  font-size: 12px;
}

.code .input .error-span {
  position: absolute;
  left: 18px;
  top: 26px;
  text-indent: -6px;
  color: #e92b2b;
  font-size: 12px;
}

.cfcaPass {
  width: 126px;
  height: 36px;
}

.install-control {
  display: block;
  width: 100%;
  height: 38px;
  line-height: 38px;
  text-indent: -30px;
}

.modal-dialog-bg {
  z-index: 9999 !important;
}

.modal-dialog-box .dialog-body {
  padding: 0 40px !important;
}

.lh25 {
  height: 25px !important;
  line-height: 25px !important;
}

.border-808080 {
  border: 1px solid #808080;
}

.user-type {
  display: inline-block;
  width: 120px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-size: 16px;
  color: #fff;
}

.user-type.current {
  background-color: #1a4997;
  border-bottom: 2px solid #fe7701;
  height: 68px;
  font-weight: bold;
}

.ml-100 {
  margin-left: 100px;
}

.browser-content {
  margin: 0 auto;
}

.browser-content > div {
  height: 30px;
  line-height: 30px;
}

.c-868686 {
  color: #868686;
}

.ml-100 {
  margin-left: 100px;
}

.w116 {
  width: 116px !important;
}

.w130 {
  width: 130px !important;
}

.w155 {
  width: 155px !important;
}

.pl15 {
  padding-left: 15px !important;
}

.btn-106-36 {
  width: 106px;
  height: 36px;
  line-height: 36px;
}
/*复选按钮*/

.btn-checkbox {
  box-sizing: content-box;
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid #205bbe;
  position: relative;
  cursor: pointer;
  top: 4px;
}

.btn-checkbox:before,
.btn-checkbox:after,
.btn-checkbox.current:before,
.btn-checkbox.current:after {
  content: "";
  display: inline-block;
  width: 2px;
  height: 12px;
  position: absolute;
  top: 2px;
  left: 10px;
  -webkit-transform: rotate(38deg);
  -moz-transform: rotate(38deg);
  -ms-transform: rotate(38deg);
  -o-transform: rotate(38deg);
  transform: rotate(38deg);
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.btn-checkbox:before {
  width: 0;
  border-left: 1px solid #205bbe;
  left: -1px;
  top: 2px;
}

.btn-checkbox:after {
  width: 0;
  border-left: 1px solid #205bbe;
  left: 15px;
  top: 2px;
}

.btn-checkbox:before,
.btn-checkbox:after {
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
}

.btn-checkbox.current:after {
  height: 6px;
  left: 5px;
  top: 7px;
  -webkit-transform: rotate(-42deg);
  -moz-transform: rotate(-42deg);
  -ms-transform: rotate(-42deg);
  -o-transform: rotate(-42deg);
  transform: rotate(-42deg);
}
.c-808080 {
  color: #808080 !important;
}
.btn-checkbox > span {
  position: absolute;
  top: -2px;
  left: 24px;
}
#smsVerifyCodeInput .error-span {
  left: 18px;
}

.ml-100 {
    margin-left: 100px;
}

.mr-20 {
    margin-right: 20px;
}

.fv-choose {
    line-height: 36px;
    padding: 5px 12px;
    border-radius: 4px;
    color: #333;
    background: #fff;
    cursor: pointer;
}

.fv-choose.current {
    line-height: 36px;
    padding: 5px 12px;
    border-radius: 4px;
    color: #fff;
    background: #1e5bbe;
}
.login-itme{
    position: relative;
}
.login-itme i{
    position: absolute;
    left: 0;
    top: 0;
    width: 35px;
    height: 35px;
}
.login-itme .i{
    position: absolute;
    left: 0;
    top: 0;
    width: 114px;
    height: 36px;
    line-height: 38px;
    padding-left: 15px;
    color: #898989;
    font-size: 14px;
    padding-right: 10px;
}
.login-itme .i:after{
    content: '';
    display: block;
    width: 1px;
    height: 15px;
    background-color: #dce1e9;
    position: absolute;
    top: 12px;
    right: 0px;
}
</style>
